<div class="change-password-page">
    <div class="change-password-wrapper">
        <mat-card class="change-password-card">
            <div class="change-password-logo-wrapper">
                <img src="/logo.png" alt="copago Logo" class="change-password-logo" />
            </div>

            <div class="change-password-header">
                <div class="header-icon">
                    <mat-icon>lock_reset</mat-icon>
                </div>

                <h1>Passwort ändern</h1>
                <p>Bitte ändern Sie Ihr initiales Passwort, bevor Sie fortfahren.</p>
            </div>

            <form class="change-password-form" [formGroup]="form" (ngSubmit)="submit()">
                <div class="form-field-group">
                    <label class="custom-label" for="currentPassword">
                        Aktuelles Passwort
                    </label>

                    <mat-form-field appearance="outline" class="full-width custom-field">
                        <input id="currentPassword" matInput formControlName="currentPassword"
                            [type]="hideCurrentPassword() ? 'password' : 'text'" autocomplete="current-password" />

                        <button mat-icon-button matSuffix type="button" (click)="toggleCurrentPasswordVisibility()">
                            <mat-icon>
                                {{ hideCurrentPassword() ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="form-field-group">
                    <label class="custom-label" for="newPassword">
                        Neues Passwort
                    </label>

                    <mat-form-field appearance="outline" class="full-width custom-field">
                        <input id="newPassword" matInput formControlName="newPassword"
                            [type]="hideNewPassword() ? 'password' : 'text'" autocomplete="new-password" />

                        <button mat-icon-button matSuffix type="button" (click)="toggleNewPasswordVisibility()">
                            <mat-icon>
                                {{ hideNewPassword() ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                        </button>
                    </mat-form-field>

                    <div class="hint">
                        Das Passwort muss mindestens 8 Zeichen lang sein.
                    </div>
                    @if (form.controls.newPassword.touched && form.controls.newPassword.hasError('minlength')) {
                    <div class="field-error">
                        Das neue Passwort muss mindestens 8 Zeichen lang sein.
                    </div>
                    }

                    @if (form.touched && form.hasError('newPasswordSameAsCurrent')) {
                    <div class="field-error">
                        Das neue Passwort darf nicht mit dem aktuellen Passwort identisch sein.
                    </div>
                    }
                </div>

                <div class="form-field-group">
                    <label class="custom-label" for="confirmPassword">
                        Neues Passwort bestätigen
                    </label>

                    <mat-form-field appearance="outline" class="full-width custom-field">
                        <input id="confirmPassword" matInput formControlName="confirmPassword"
                            [type]="hideConfirmPassword() ? 'password' : 'text'" autocomplete="new-password" />

                        <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPasswordVisibility()">
                            <mat-icon>
                                {{ hideConfirmPassword() ? 'visibility_off' : 'visibility' }}
                            </mat-icon>
                        </button>
                    </mat-form-field>
                    @if (form.controls.confirmPassword.touched && form.hasError('passwordsNotMatching')) {
                    <div class="field-error">
                        Das neue Passwort und die Bestätigung stimmen nicht überein.
                    </div>
                    }
                </div>

                @if (serverError()) {
                <div class="server-error">
                    {{ serverError() }}
                </div>
                }

                <button mat-flat-button type="submit" class="change-password-button" [disabled]="isSubmitting()">
                    @if (!isSubmitting()) {
                    <span>Passwort ändern</span>
                    } @else {
                    <mat-spinner diameter="20"></mat-spinner>
                    }
                </button>
                <button mat-stroked-button type="button" class="logout-button" (click)="logout()"
                    [disabled]="isSubmitting()">
                    Abmelden
                </button>
            </form>
        </mat-card>
    </div>
</div>